// Product categories for Okinawa Sign Studio

export const productCategories = [
  {
    id: 'led-neon-signs',
    name: 'LED Neon Signs',
    slug: 'led-neon-signs',
    description: 'Modern LED neon signs that capture the classic neon aesthetic with modern technology. Safe, cool to touch, and incredibly vibrant.',
    features: [
      'Classic neon look with LED technology',
      'Safe and cool to touch',
      '30+ vibrant color options',
      'Dimmable brightness',
      'Custom text and designs'
    ],
    priceRange: '',
    hasCustomizer: true,
    gallery: [
      { id: 1, title: 'Burger Neon Sign', image: 'https://images.unsplash.com/photo-1562226581-8afad1af1f3a?w=800' },
      { id: 2, title: 'Pancakes Neon Sign', image: 'https://images.unsplash.com/photo-1562226581-ac03c28fff50?w=800' },
      { id: 3, title: 'Restaurant Neon', image: 'https://images.unsplash.com/photo-1562226581-a5121882eec8?w=800' },
      { id: 4, title: 'Beer Garden Neon', image: 'https://images.unsplash.com/photo-1765966869338-04e5e64e3711?w=800' },
      { id: 5, title: 'Custom Neon Text', image: 'https://images.unsplash.com/photo-1554290712-e640351074bd?w=800' },
      { id: 6, title: 'Business Neon Logo', image: 'https://images.unsplash.com/photo-1496449903678-68ddcb189a24?w=800' }
    ]
  },
  {
    id: 'led-signs',
    name: 'LED Signs',
    slug: 'led-signs',
    description: 'Bright, energy-efficient LED signs perfect for businesses, events, and home decor. Our LED signs offer vibrant illumination with long-lasting performance.',
    features: [
      'Energy efficient LED technology',
      'Bright and vibrant illumination',
      'Long lifespan (50,000+ hours)',
      'Indoor and outdoor options',
      'Custom sizes available'
    ],
    priceRange: '',
    gallery: [
      { id: 1, title: 'Business LED Sign', image: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800' },
      { id: 2, title: 'Restaurant LED Display', image: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=800' },
      { id: 3, title: 'Retail LED Signage', image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800' },
      { id: 4, title: 'Custom LED Logo', image: 'https://images.unsplash.com/photo-1528698827591-e19ccd7bc23d?w=800' },
      { id: 5, title: 'Shop LED Sign', image: 'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=800' },
      { id: 6, title: 'Storefront LED', image: 'https://images.unsplash.com/photo-1534452203293-494d7ddbf7e0?w=800' }
    ]
  },
  {
    id: 'channel-letter-signs',
    name: 'Channel Letter Signs',
    slug: 'channel-letter-signs',
    description: 'Professional 3D channel letter signs for storefronts and businesses. Available in front-lit, back-lit, and combination styles.',
    features: [
      '3D dimensional letters',
      'Front-lit, back-lit, or halo-lit options',
      'Durable aluminum construction',
      'Weather-resistant for outdoor use',
      'Custom fonts and colors'
    ],
    priceRange: '',
    gallery: [
      { id: 1, title: 'Storefront Channel Letters', image: 'https://images.unsplash.com/photo-1584444279613-a2c76483b6cc?w=800' },
      { id: 2, title: 'Building 3D Letters', image: 'https://images.unsplash.com/photo-1743887909609-2dc6e63c78d0?w=800' },
      { id: 3, title: 'Modern Channel Sign', image: 'https://images.unsplash.com/photo-1765097715917-c3b39538ec24?w=800' },
      { id: 4, title: 'Cafe Channel Letters', image: 'https://images.unsplash.com/photo-1762868387680-ac65a289f879?w=800' },
      { id: 5, title: 'Shop Sign Letters', image: 'https://images.unsplash.com/photo-1767800774302-819cdf97ef04?w=800' },
      { id: 6, title: 'Restaurant Channel Letters', image: 'https://images.unsplash.com/photo-1758384076174-2087e5a1a998?w=800' }
    ]
  },
  {
    id: 'acrylic-signs',
    name: 'Acrylic Signs',
    slug: 'acrylic-signs',
    description: 'Sleek and modern acrylic signs perfect for offices, lobbies, and professional spaces. Crystal clear or colored options available.',
    features: [
      'Premium acrylic material',
      'Clear, frosted, or colored options',
      'Modern and professional look',
      'Laser-cut precision',
      'Wall-mounted or freestanding'
    ],
    priceRange: '',
    gallery: [
      { id: 1, title: 'Office Acrylic Sign', image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800' },
      { id: 2, title: 'Reception Signage', image: 'https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=800' },
      { id: 3, title: 'Corporate Lobby Sign', image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800' },
      { id: 4, title: 'Directional Acrylic', image: 'https://images.unsplash.com/photo-1497215842964-222b430dc094?w=800' },
      { id: 5, title: 'Business Logo Acrylic', image: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=800' },
      { id: 6, title: 'Modern Acrylic Display', image: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=800' }
    ]
  },
  {
    id: 'metal-signs',
    name: 'Metal Signs',
    slug: 'metal-signs',
    description: 'Durable and timeless metal signs crafted from premium materials. Perfect for industrial, rustic, or modern aesthetics.',
    features: [
      'Premium aluminum or steel',
      'Rust-resistant coating',
      'Brushed, polished, or painted finishes',
      'Indoor and outdoor durability',
      'Custom shapes and sizes'
    ],
    priceRange: '',
    gallery: [
      { id: 1, title: 'Metal Logo Sign', image: 'https://images.unsplash.com/photo-1630644964646-6cc8ac5b47ea?w=800' },
      { id: 2, title: 'Museum Metal Sign', image: 'https://images.unsplash.com/photo-1608572256670-e21ee2e6fe4e?w=800' },
      { id: 3, title: 'Building Metal Letters', image: 'https://images.unsplash.com/photo-1765097715917-c3b39538ec24?w=800' },
      { id: 4, title: 'Metal Wall Art Sign', image: 'https://images.unsplash.com/photo-1716242290710-3bd1ef461759?w=800' },
      { id: 5, title: 'Vintage Metal Signage', image: 'https://images.unsplash.com/photo-1524634126442-357e0eac3c14?w=800' },
      { id: 6, title: 'Custom Metal Letters', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800' }
    ]
  },
  {
    id: 'lightbox-signs',
    name: 'Lightbox Signs',
    slug: 'lightbox-signs',
    description: 'Eye-catching illuminated lightbox signs that make your brand stand out day and night. Perfect for storefronts and displays.',
    features: [
      'Even LED illumination',
      'Single or double-sided options',
      'Easy graphic changes',
      'Slim profile design',
      'Indoor and outdoor models'
    ],
    priceRange: '',
    gallery: [
      { id: 1, title: 'Storefront Lightbox', image: 'https://images.unsplash.com/photo-1582018960590-f3bc3ea25c04?w=800' },
      { id: 2, title: 'Illuminated Sign', image: 'https://images.unsplash.com/photo-1555676928-f338d0892c0b?w=800' },
      { id: 3, title: 'Business Lightbox', image: 'https://images.unsplash.com/photo-1768812785179-ab5add1e2e1c?w=800' },
      { id: 4, title: 'Advertising Lightbox', image: 'https://images.unsplash.com/photo-1660919744593-12fd28edc6a8?w=800' },
      { id: 5, title: 'LED Display Sign', image: 'https://images.unsplash.com/photo-1648090587866-7c63a4ac6547?w=800' },
      { id: 6, title: 'Night Lightbox Sign', image: 'https://images.unsplash.com/photo-1590036194560-ce1524587e4e?w=800' }
    ]
  },
  {
    id: 'custom-signs',
    name: 'Any Custom Sign',
    slug: 'custom-signs',
    description: 'Have a unique vision? We create fully custom signs tailored to your exact specifications. Any material, any style, any size.',
    features: [
      'Fully customizable design',
      'Any material combination',
      'Unique shapes and sizes',
      'Professional design consultation',
      'One-of-a-kind creations'
    ],
    priceRange: '',
    gallery: [
      { id: 1, title: 'Custom Art Installation', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800' },
      { id: 2, title: 'Unique Business Sign', image: 'https://images.unsplash.com/photo-1524634126442-357e0eac3c14?w=800' },
      { id: 3, title: 'Creative Signage', image: 'https://images.unsplash.com/photo-1554290712-e640351074bd?w=800' },
      { id: 4, title: 'Mixed Material Sign', image: 'https://images.unsplash.com/photo-1514933651103-005eec06c04b?w=800' },
      { id: 5, title: 'Artistic Display', image: 'https://images.unsplash.com/photo-1567677917221-3229fddf8d73?w=800' },
      { id: 6, title: 'Bespoke Signage', image: 'https://images.unsplash.com/photo-1709483071040-eddd07754784?w=800' }
    ]
  }
];

export const getProductBySlug = (slug) => {
  return productCategories.find(product => product.slug === slug);
};
